// Le widget « Élèves actifs · aujourd'hui » de l'accueil de l'app, côté coach
// (thème sombre) : un élève par ligne, liseré teal, avatar à initiales,
// « S'entraîne aujourd'hui » et le bouton œil qui ouvre le mode coach.
// D'après screens/home/ElevesActifsToday.js.
import React from "react";
import Apercu from "./Apercu";

const ACTIFS = [
	{ initiales: "CH", nom: "Chloé" },
	{ initiales: "HU", nom: "Hugo" },
];

export default function ApercuElevesActifs({ className = "" }) {
	return (
		<Apercu
			className={className}
			description="Accueil de l'app côté coach : élèves actifs aujourd'hui, Chloé et Hugo s'entraînent, avec un bouton pour suivre leur séance."
		>
			<div className="gs-ea">
				<div className="gs-ea-tete">
					<span>Élèves actifs · aujourd'hui</span>
					<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
						<path d="M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7" />
					</svg>
				</div>
				{ACTIFS.map((e, i) => (
					<div key={e.nom} className="gs-ea-ligne gs-a-etape" style={{ "--i": i }}>
						<span className="gs-ea-avatar">{e.initiales}</span>
						<span className="gs-ea-texte">
							<b>{e.nom}</b>
							<span>S'entraîne aujourd'hui</span>
						</span>
						<span className="gs-ea-oeil">
							<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
								<circle cx="12" cy="12" r="3" />
							</svg>
						</span>
					</div>
				))}
			</div>
		</Apercu>
	);
}
